module.exports = __webpack_public_path__ + "static/img/oregon-coast-wayside-signs06.47ca2e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/oregon/oregon-coast-wayside-signs06.jpg
// module id = 869
// module chunks = 0